import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Srgcomplex from './components/pages/Srgcomplex';
import Facilitypage from './components/pages/Facilitypage';
import Contactus from './components/pages/Contactus';
import Aboutus from './components/pages/Aboutus';
import Bhk3villa from './components/pages/Bhk3villa';
import Bhk4villa from './components/pages/Bhk4villa';
import LandSale from './components/pages/LandSale';
import OngoingPage from './components/pages/OngoingPage';
function App() {
  return (
       <Router>
      
    
    <div>

     
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
        <Route axact path="/SRGcomplex" element={<Srgcomplex/>}/>
          <Route axact path="/facility" element={<Facilitypage/>}/>
            <Route axact path="/Contactus" element={<Contactus/>}/>
            <Route axact path="/about-us" element={<Aboutus/>}/>
                 <Route axact path="/3bhk-villa" element={<Bhk3villa/>}/>
                      <Route axact path="/4bhk-villa" element={<Bhk4villa/>}/>
                          <Route axact path="/land-premium" element={<LandSale/>}/>
                          <Route axact path="/srg-ongoingproject" element={<OngoingPage/>}/>

          </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
